module.exports = __webpack_public_path__ + "static/media/question-mark.a42f1849.svg";